import React from "react";
import { Link } from "react-router-dom";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import SidebarIcon from "./SidebarIcon";
import style from "./SectionTitleRow.module.css";

function SectionTitleRowContent({
  title,
  icon,
  selected,
  compact,
  onClick,
}: SectionTitleRowProps) {
  const classes = [
    style.sectionTitle,
    selected ? style.selected : "",
    compact ? style.compact : "",
  ]
    .filter(Boolean)
    .join(" ");

  const handleClick = (event: React.MouseEvent) => {
    onClick?.(event);
  };

  return (
    <div
      className={classes}
      onClick={handleClick}
      title={compact ? title : undefined}
    >
      <SidebarIcon icon={icon} className={style.icon} />
      {!compact && <span className={style.label}>{title}</span>}
    </div>
  );
}

type SectionTitleRowProps = {
  title: string;
  icon: IconDefinition;
  selected?: boolean;
  compact?: boolean;
  link?: string;
  onClick?: (event: React.MouseEvent) => void;
};

function SectionTitleRow(props: SectionTitleRowProps) {
  const { link } = props;

  if (!link) {
    return <SectionTitleRowContent {...props} />;
  }

  return (
    <Link
      to={link}
      className={style.link}
      onClick={(event) => props.onClick?.(event)}
    >
      <SectionTitleRowContent {...props} />
    </Link>
  );
}

export default SectionTitleRow;
